<template>
  <roe-modal
    ref="rightPanel"
    wrap-class="right-panel-wrap"
    :close-on-click-outside="false"
  >
    <div class="right-panel" v-click-outside="close">
      <div class="right-panel-header with-close-btn">
        <h2>Research</h2>
        <button class="btn-close" @click="close()"></button>
      </div>
      <div class="right-panel-content pdf-right-panel-content">
        <roe-selected-articles :articles="articles"> </roe-selected-articles>
        <roe-select-articles
          :category-articles="categoryArticles"
          :selected-articles="articles"
        >
        </roe-select-articles>
      </div>
    </div>
  </roe-modal>
</template>
<script>
import RoeModal from "@/components/_shared/Modal";
import RoeSelectedArticles from "./ArticleSelected";
import RoeSelectArticles from "./ArticleSelect";
import { FLASH_MESSAGE_RESET_POSITION } from "@/store/mutations.type";
export default {
  name: "RoeArticleForm",
  components: { RoeSelectArticles, RoeSelectedArticles, RoeModal },
  props: {
    categoryArticles: {
      type: Object,
      required: true
    },
    articles: {
      type: Array,
      required: true
    }
  },
  methods: {
    open() {
      this.$refs.rightPanel.open();
    },
    close() {
      if (this.$refs.rightPanel.close())
        this.$store.commit(FLASH_MESSAGE_RESET_POSITION);
    }
  }
};
</script>
